import React from 'react';
import { Popup } from "components/popups/Popup";
import Button from "components/shared/button";

import useTranslation from "utils/hooks/useTranslation";


export const HelpSidePopup: React.FC<{
    closePopup: any;
    children: React.ReactNode;
}> = ({
    closePopup,
    children
}) => {
        const { t } = useTranslation();

        return (
            <Popup
                title={t("HEATLOSS_CALCULATION_TITLE")}
                translateTitle
                fixSize={"medium"}
                commandPanelProps={{
                    additionalElement: (
                        <group data-justify="start" data-gap="20">
                            <Button
                                data-length="forcefit"
                                // accent
                                secondary
                                large
                                onClick={() => {
                                    closePopup();
                                }}
                            >
                                {t("CLOSE")}
                            </Button>
                            {/* <Button
                                data-length="forcefit"
                                secondary
                                large
                                // onClick={handleSubmit(onSubmit)}
                            >
                                {t("NAV_SAVE")}
                            </Button> */}
                        </group>
                    )
                }}
            >
                {/* {isLoading && <Loader />} */}
                <group
                    data-direction="column"
                    data-gap="20"
                    data-space="40"
                    data-space-horizontal="40"
                    data-space-top="5"
                    data-height="autofit"
                >
                    <group data-gap="20" data-custom="">
                        {
                            children
                        }
                    </group>
                </group>
            </Popup>
        )
    };